import type { IconSvgObject } from './types';

const ThreeDRotateIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 12C7.18491 16.8269 16.4642 16.3877 22 12.3556", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5368 2C6.98945 6.5 6.48414 17 11.9941 22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ThreeDRotateIcon;
